// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TTd9T","footer":"styles_footer__2agcq"};